// @ts-nocheck
import {Button} from "@mui/material";
import {styled} from '@mui/material/styles';

export const BotonSecondary = styled(Button)(()  => ({
    // backgroundColor: 'rgb(171, 0, 60)',
    color:'rgb(171, 0, 60)',
    // borderColor: 'rgb(171, 0, 60)',
    margin:'0 5px',
    '&:hover': {
        borderColor: '#83002f',
    },
}));